import { set, when } from 'cerebral/operators'
import { state, props, resolveObject } from 'cerebral/tags'
import filesDroppedOnNode from '../factories/filesDroppedOnNode'
import createSnackbar from 'modules/App/factories/createSnackbar'
import deselectAllFiles from 'modules/Media/chains/deselectAllFiles'

export default [
  set(state`media.dragging`, false),
  function({ state }) {
    return {
      count: state.get('media.selectedFiles').length
    }
  },
  when(
    state`media.keyboard.keys.17`,
    state`media.keyboard.keys.18`,
    (ctrl, alt) => ctrl || alt
  ),
  {
    false: [
      when(
        state`node.selectedNode.id`,
        state`node.drop.id`,
        (current, next) => current === next
      ),
      {
        true: [
          createSnackbar({ key: 'bms.media.errors.movingToSameNode' }, 'error')
        ],
        false: [
          filesDroppedOnNode('moveMedias'),
          ...deselectAllFiles,
          createSnackbar(
            resolveObject({
              key: 'bms.media.event.filesRemoved',
              params: resolveObject({
                count: props`count`
              })
            })
          )
        ]
      }
    ],
    true: [
      filesDroppedOnNode('copyMedia'),
      createSnackbar(
        resolveObject({
          key: 'bms.media.copy.start',
          params: resolveObject({
            count: props`count`,
            nodeName: state`${state`node.drop.path`}.name`
          })
        }),
        'normal'
      ),
      ({ props, state }) => {
        state.set(`app.events.copy.${props.copyMedia}`, {
          count: props.count,
          nodeName: state.get(`${state.get('node.drop.path')}.name`),
          snackbar: { id: props.snackbar.id }
        })
      }
    ]
  },
  set(state`node.drop.id`, null)
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/endDragMedia.js